import '../styles/ui.css';

export default function ModalShell({ title, onClose, children, footer, width }) {
  return (
    <div className="ui-modal-backdrop" onClick={onClose}>
      <div className="ui-modal" style={width ? { width } : undefined} onClick={(e) => e.stopPropagation()}>
        <div className="ui-modal__header">
          <h3 className="ui-modal__title">{title}</h3>
          <button type="button" className="ui-button ghost" style={{ height: 32 }} onClick={onClose}>
            ×
          </button>
        </div>
        <div className="ui-modal__body">
          <div className="ui-modal__body-scroll">
            {children}
          </div>
        </div>
        {footer && <div className="ui-modal__footer">{footer}</div>}
      </div>
    </div>
  );
}
